import React from "react";
import { useInView } from 'react-intersection-observer';

export default function Credits() {
    
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

    return (
        <div ref={ref} className={`row fade-right ${inView ? 'visible' : ''}`}>
            <div className="col-lg-4 col-md-3 col-sm-6 col-6 mb-5">
                <div className="credits-item d-flex flex-column align-items-center">
                    <img src={require("../../assets/Images/customer-support.png")} alt="insurance" style={{width : '66px'}}/>
                    <div className="heading7 text-center mt-3">Customer Service</div>
                    <div className="caption1 text-center mt-3">We&apos;re here to help you with any questions or concerns you have, Open 10 AM to 6 PM.</div>
                </div>
            </div>
            {/* <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-5">
                <div className="credits-item d-flex flex-column align-items-center">
                    <i className="bi bi-bootstrap-reboot text-6xl"></i>
                    <div className="heading7 text-center mt-3">14-Day Money Back</div>
                    <div className="caption1 text-center mt-3">If you&apos;re not satisfied with your purchase, simply return it within 14 days for a refund.</div>
                </div>
            </div> */}
            <div className="col-lg-4 col-md-3 col-sm-6 col-6 mb-5">
                <div className="credits-item d-flex flex-column align-items-center">
                    <img src={require("../../assets/Images/insurance.png")} alt="insurance" style={{width : '66px'}}/>
                    <div className="heading7 text-center mt-3">Our Guarantee</div>
                    <div className="caption1 text-center mt-3">We stand behind our products and services and guarantee your satisfaction.</div>
                </div>
            </div>
            <div className="col-lg-4 col-md-3 col-sm-6 col-6 mb-5">
                <div className="credits-item d-flex flex-column align-items-center">
                                        <img src={require("../../assets/Images/express-delivery.png")} alt="insurance" style={{width : '66px'}}/>

                    <div className="heading7 text-center mt-3">Shipping All Over India</div>
                    <div className="caption1 text-center mt-3">We ship our products all over india, making them accessible to customers everywhere.</div>
                </div>
            </div>
        </div>
    );
}